// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NrFd","name":"styles_name__bBLWP","phone":"styles_phone__GtbWy"};